import { Grid, Stack } from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

import TransparentFragment from "../../../../helper-components/misc/TransparentFragment";
import CustomButton from "../../../../helper-components/input/CustomButton";

export default function GetReadyPlaque(props) {
    const { handleNext, handleSkipPlaque, chartSeparately, setChartSeparately } = props;

    const SelectionButtons = () => {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <TransparentFragment value={`Do you want to chart plaque separately?`} />
                </Grid>

                <Grid item xs={12}>
                    <Stack direction="row" spacing={1} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
                        <CustomButton {...props} title="Yes" onClick={handleYes} variant="outlined" fullWidth startIcon={<CheckIcon />} className="button-large-v2" />
                        <CustomButton {...props} title="No" onClick={handleNo} variant="outlined" fullWidth startIcon={<CloseIcon />} className="button-large-v2" />
                    </Stack>
                </Grid>
            </Grid>
        );
    };

    const GetReady = () => {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <TransparentFragment title={`Get ready to chart plaque locations`} center p={8} />
                </Grid>
            </Grid>
        );
    };

    const handleYes = () => {
        setChartSeparately(true);
        handleNext();
    };

    const handleNo = () => {
        if (handleSkipPlaque) {
            handleSkipPlaque();
            return;
        }

        setChartSeparately(false);
        handleNext();
    };

    return chartSeparately ? GetReady() : SelectionButtons();
}
